module.exports = __webpack_public_path__ + "img/purple-3-diamond-striped.1bf6ffb2.svg";